<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <main-filter
      @getResult="setRows"
      :withSearch="false"
      price
      withSizes
      withColors
    />
    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <MainLoader key="loader" v-if="loading" />
      <!-- End Main Loader -->

      <div key="main" v-else>
        <!-- Start Statistics Card-->
        <!-- <div class="row mb-5">
          <div class="wrraper">
            <stats-card
              :title="$t('ordersNum')"
              :number="statisticsItem.number"
            ></stats-card>
          </div>
        </div> -->
        <!-- End Statistics Card-->

        <!-- Start Main Section -->
        <main>
          <v-data-table
            class="elevation-1 thumb diff_table"
            :headers="headers"
            :items="rows"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <!-- avatar -->
            <template v-slot:[`item.image`]="{ item }">
              <img
                @click="show_model_1"
                class="image"
                :src="item.product.image"
              />
            </template>

            <!-- Start:: Users Routes -->
            <template v-slot:[`item.bank_name`]="{ item }">
              <span>
                {{ item.bank_name + " " + item.branch + " " + item.city }}
              </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <span
                class="status"
                :class="item.quantity > 0 ? 'paid' : 'unpaid'"
              >
                {{ item.quantity > 0 ? "في المخزون" : "خارج المخزون" }}
              </span>
            </template>

            <template v-slot:[`item.amount`]="{ item }">
              <span>{{ item.amount + " " + item.currency }}</span>
            </template>

            <template v-slot:[`item.quantity`]="{ item }">
              <v-chip label outlined>{{ item.quantity }}</v-chip>
              <v-btn
                @click="edit_quantity(item)"
                class="ma-2"
                text
                icon
                color="lighten-2"
              >
                <v-icon>fal fa-edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.color`]="{ item }">
              <span
                class="color"
                v-if="item.color"
                :style="{ backgroundColor: item.color.hex }"
              ></span>
              <span
                class="text"
                v-if="item.color"
                :style="{ color: item.color.hex }"
              >
                {{ item.color.ar.name }}
              </span>
            </template>

            <template v-slot:[`item.to`]="{ item }">
              <router-link :to="`/users/show/${item.to.id}`">
                {{ item.to.fullname }}
              </router-link>
            </template>
            <!-- End:: Users Routes -->

            <!-- Start:: Report Reason Modal Button -->
            <template v-slot:[`item.report_reason`]="{ item }">
              <v-icon
                class="show"
                small
                @click="controlReportReasonModalModal(item.report_reason)"
                v-if="item.report_reason"
              >
                fal fa-eye
              </v-icon>

              <span v-else>_</span>
            </template>
            <!-- End:: Report Reason Modal Button -->

            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="show" small @click="showItem(item)">
                  fal fa-eye
                </v-icon>
                <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
                <!-- <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon> -->
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <h3 class="title table-title">
                المخزون
                <!-- {{ statisticsItem.number }} -->
              </h3>
              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    {{ $t("table.deletedialog.areYouSure") }}
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm">
                      {{ $t("table.deletedialog.ok") }}
                    </v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">
                      {{ $t("table.deletedialog.cancel") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Edit Quantity -->
              <v-dialog v-model="editQuantity" max-width="500px">
                <div class="quantity_card">
                  <div class="card_header">
                    <h4>تعديل الكمية</h4>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="quantity"
                        />
                        <label for="name_input" class="form-label">
                          {{ $t("forms.labels.quantity") }}
                        </label>
                      </div>
                    </div>
                    <div class="buttons_wrapper">
                      <button
                        class="base-btn"
                        @click="updateQuantity"
                        type="button"
                      >
                        {{ $t("forms.submit") }}
                        <span class="btn_loader" v-if="btnIsLoading"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </v-dialog>

              <!-- Start:: Text Content Modal -->
              <TextContentModal
                @toggleModal="controlReportReasonModalModal"
                :modalIsActive="reportReasonModalIsOpen"
                :title="$t('reportReason')"
                :textContent="reportReasonToShow"
              />
              <!-- End:: Text Content Modal -->
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <template>
          <div
            class="pagination_container tw-text-center mb-5 d-flex justify-content-between"
          >
            <div class="select-pagination d-flex">
              <span class="first">{{ $t("show") }}</span>
              <v-select
                :items="[5, 20, 50, 100]"
                v-model="paginations.items_per_page"
              ></v-select>
              <span>{{ $t("entries") }}</span>
            </div>

            <v-pagination
              v-model.number="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="5"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import TextContentModal from "@/components/Modals/TextContentModal.vue";
// End:: Importing Modals

export default {
  name: "UsersReports",

  components: {
    TextContentModal,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.stock-tracking.title"),
          disabled: true,
          href: "",
        },
        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",
      btnIsLoading: false,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,
      editQuantity: false,
      quantityToEdit: null,
      quantity: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Loading
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "الصورة",
            align: "center",
            value: "image",
            sortable: true,
          },
          {
            text: "اسم المنتج",
            align: "center",
            value: "product.name",
            sortable: false,
          },
          {
            text: "اللون",
            align: "center",
            value: "color",
            sortable: false,
          },
          {
            text: "الحالة",
            align: "center",
            value: "status",
            sortable: false,
          },
          {
            text: "الكمية",
            align: "center",
            value: "quantity",
            sortable: false,
          },
          {
            text: "السعر",
            align: "center",
            value: "price",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // ===== Toggle Report Reason Modal =====
    controlReportReasonModalModal(selectedReportReason) {
      this.reportReasonToShow = selectedReportReason;
      this.reportReasonModalIsOpen = !this.reportReasonModalIsOpen;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/orders/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/orders/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/orders/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `order/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },

    // ===== Edit
    edit_quantity(item) {
      this.editQuantity = true;
      this.quantityToEdit = item;
    },

    updateQuantity() {
      if (!this.quantity) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.quantity"),
          position: "bottomRight",
        });
      } else {
        this.btnIsLoading = true;
        let submit_data = new FormData();
        submit_data.append("_method", "PATCH");
        submit_data.append("quantity", this.quantity);
        this.axios({
          method: "POST",
          url: `products/${this.quantityToEdit.product.id}/details/${this.quantityToEdit.id}`,
          data: submit_data,
        })
          .then(() => {
            this.editQuantity = false;
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("addSuccess"),
              position: "bottomRight",
            });
            this.setRows();
            this.btnIsLoading = false;
          })
          .catch((err) => {
            this.btnIsLoading = false;
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      }
    },

    // ==================== End CRUD ====================

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // Set Rows
    setRows() {
      this.loading = true;
      this.btnIsLoading = true;
      const params = new URLSearchParams();
      params.append("from_price", e?.start_price ? e.start_price : "");
      params.append("to_price", e?.end_price ? e.end_price : "");
      params.append("size", e?.size ? e.size.id : "");
      params.append("color", e?.color ? e.color.id : "");

      params.append("page", this.paginations.current_page);
      this.axios({
        method: "GET",
        url: "stock-tracking",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.statisticsItem.number = res.data.meta.total;
          this.btnIsLoading = false;
          this.loading = false;
        })
        .catch(() => {
          this.btnIsLoading = false;
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },

  // ======= hooks
};
</script>

<style lang="scss" scoped>
span.color {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-inline-end: 10px;
}
.quantity_card {
  background: var(--cardBgColor);
  border-radius: 12px;
  box-shadow: 0 0 0;
  padding: 15px 20px;
  overflow: hidden;
  .card_header {
    @include flexCenterAlignment;
  }
}
</style>
